import { nullable2undefinable } from 'core/utils/commonUtils';
import { http } from 'core/utils/httpClient';
import type { CreateOrUpdateProductGroupRequest } from './dtoModels/productGroup/createOrUpdateProductGroupRequest';
import type { ProductGroupResponse } from './dtoModels/productGroup/productGroupResponse';
import type { ProductGroup } from 'models/product/productGroup';

const mapProductGroup = (source: ProductGroupResponse): ProductGroup => ({
  ...source,
  parentId: nullable2undefinable(source.parentId),
  groups: mapProductGroups(source.groups),
});

const mapProductGroups = (source: ProductGroupResponse[]): ProductGroup[] =>
  source.map((s) => mapProductGroup(s));

export async function getProductsGroupsAsync(): Promise<ProductGroup[]> {
  const { data } = await http.get<ProductGroupResponse[]>('group-products');
  return mapProductGroups(data);
}

export async function createProductGroupAsync(
  request: CreateOrUpdateProductGroupRequest
): Promise<ProductGroup> {
  const { data } = await http.post<ProductGroupResponse>('group-products', request);
  return mapProductGroup(data);
}

export async function saveProductGroupAsync(
  groupId: number,
  request: CreateOrUpdateProductGroupRequest
): Promise<ProductGroup> {
  const { data } = await http.put<ProductGroupResponse>(
    `group-products/${groupId}`,
    request
  );
  return mapProductGroup(data);
}

export async function deleteProductGroupAsync(groupId: number): Promise<void> {
  const { data } = await http.delete(`group-products/${groupId}`);
  return data;
}
